import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

export default function FacebookIcon({ fill = '#0866FF', icon = '#FFF' }) {
    return (
        <SvgIcon sx={{ width: { xs: 44, md: 48 }, height: { xs: 44, md: 48 } }}>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill={fill} />
                <path
                    d="M29.4318 25.3318L30.0502 21.9571H26.4414V20.7644C26.4414 18.9799 27.1393 18.2952 28.9503 18.2952C29.5113 18.2952 29.9663 18.3085 30.2269 18.335V15.2739C29.7322 15.1369 28.5263 15 27.8284 15C24.14 15 22.4394 16.7404 22.4394 20.4994V21.9571H20.1602V25.3318H22.4394V33H25.1074H26.4458V25.3318H29.4318Z"
                    fill={icon}
                />
            </svg>
        </SvgIcon>
    );
}
